import { collections } from "@/mocks/home";

export default function CollectionShowcase() {
  return (
    <section id="collections" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full max-w-[1180px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <p className="text-xs tracking-[0.2em] text-primary-700 uppercase">Collections</p>
            <h4 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">
              <a href="#collections" className="cursor-pointer hover:text-primary-700 transition-colors">
                精选入口合集
              </a>
            </h4>
            <p className="mt-3 text-sm text-foreground-600 max-w-2xl leading-relaxed">
              按使用场景整理好的合集，比单个地址更好记。想省事就直接从合集会里挑一个。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5">
          {collections.map((c) => (
            <article
              key={c.id}
              className="group rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
            >
              <div className="w-full h-[200px] overflow-hidden">
                <img
                  src={c.image}
                  alt={`${c.title}合集配图`}
                  title={`琉璃神社${c.title}`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between gap-3">
                  <h5 className="font-heading text-lg text-foreground-950">{c.title}</h5>
                  <span className="shrink-0 px-2.5 py-0.5 rounded-full text-[11px] bg-accent-100 text-accent-900 border border-accent-200 whitespace-nowrap">
                    {c.count}
                  </span>
                </div>
                <p className="mt-2 text-[13px] text-foreground-600 leading-relaxed">{c.summary}</p>
                <a
                  href="#mirrors"
                  className="mt-4 inline-flex items-center gap-1 text-[13px] text-primary-700 cursor-pointer hover:text-primary-800 transition-colors"
                >
                  查看合集入口
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}